import styled from 'styled-components';

import { widgetPanelShared } from './shared.styles';

export const MainContent = styled.main`
  flex-direction: column;
  display: flex;
  flex: 1;
  height: 100%;
  align-items: center;
  max-height: 100%;
  min-width: 800px;
  padding-top: 20px;
  padding-bottom: 88px;
`;

export const WidgetsDashboard = styled.section`
  display: grid;
  gap: 20px;
  grid-template-columns: 67% 33%;
  height: 100%;
  min-width: 860px;
  width: 80vw;
  max-width: 1100px;
  grid-template-rows: 32px 200px 440px 440px;
  grid-template-areas:
    '. mode'
    'indicators indicators'
    'news calendar'
    'watchlist watchlist';
`;

export const MidContainer = styled.div`
  ${widgetPanelShared};
  grid-area: indicators;
`;

export const LeftWidgetContainer = styled.div`
  ${widgetPanelShared};
  grid-area: news;
`;

export const RightWidgetContainer = styled.div`
  ${widgetPanelShared};
  grid-area: calendar;
`;

export const BottomContainer = styled.div`
  ${widgetPanelShared};
  grid-area: watchlist;
`;
